import { ChatIcon } from "@chakra-ui/icons";
import { Box, Text } from "@chakra-ui/react";

export default function ChatHelpIcon() {
    return (
        <Box position="relative">
            <ChatIcon w={6} h={6} />
            <Text
                w={3} h={3}
                position="absolute"
                top="2px"
                left="6px"
                fontSize="sm"
            >
                ?
            </Text>
        </Box>
    );
}
